import React, { useState, useSyncExternalStore } from 'react';
import RawEntry from "../../components/RawEntry";
import { RawEntryConfig } from "../../components/RawEntry"
import { Routes, Route } from "react-router-dom";
import UserRender from "./UserRender"
import '../../Default.css';
import './Users.css';

import UserType from './usersType'
import { userStateStore } from './usersStateStore';

function searchIncludesTerm(elem: string, searchTerm: string): boolean {
    return elem.toLowerCase().includes(searchTerm.toLowerCase())
}

function searchIncludesTermNumber(elem: number, searchTerm: string): boolean {
    return elem.toString().toLowerCase().includes(searchTerm.toLowerCase())
}

function ifElemIncludesTerm(elem: UserType, searchTerm: string): boolean {
  if(searchIncludesTerm(elem.name, searchTerm) || searchIncludesTerm(elem.surname, searchTerm)|| searchIncludesTermNumber(elem.zhr_code, searchTerm))
   return true;
  return false;
}


function getMenuItems(searchTerm: string, users: UserType[]): RawEntryConfig[] {
  //@ts-ignore
  return users.map((elem,index) =>
  {
    if(searchTerm === "" || ifElemIncludesTerm(elem, searchTerm))
      return {
        //@ts-ignore
        link: `./${elem._id}`,
        text: elem.name + " " + elem.surname
      } as RawEntryConfig
    else return null;
  }).filter((v) => v !== null)
}


function UsersMenu(users: UserType[]) {
    const [searchTerm, setSearchTerm] = useState("");
    // console.log(users)
    return (
        <>
            <div>
                <div className="page-title">
                    Użytkownicy
                </div>
                <div className='form'>
                    <input type="text" placeholder='Wyszukuj...' onChange={(event) => {
                        setSearchTerm(event.target.value);
                    }}/>
                </div>
            </div>
            <div className="users navigation-wraper">
                <nav className='small-nav-bar navigation-bar'>
                    {getMenuItems(searchTerm, users).map((v) => RawEntry(v))}
                </nav>
            </div>
          
        </>
    );
}
  
function Users() {
    // const [users, setUsers] = useState<UserType[]>([]);

    // useEffect(() => {
    //     fetch('/api/user/users').then(r => r.json()).then(r => setUsers(r as UserType[]))
    // });

    const users = useSyncExternalStore(userStateStore.subscribeAny,userStateStore.getUsersArray)

    return (
        <>
            <Routes>
                <Route path='/' element={UsersMenu(users)}></Route>
                {users.map((entry) => 
                    <Route path={`/${entry._id}/*`} key={entry._id.toString()} Component={UserRender.bind(null,entry._id)}/>
                )}
            </Routes>
        </>
    );
  }
  
  export default Users;